import React from "react";
import { SideMenu, DateRangePicker } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Rating from "@mui/material/Rating";
import { IoMdAnalytics } from "react-icons/io";
import "./rating.css";
import { useNavigate } from "react-router-dom";
let RatingPage = () => {
  const navigate = useNavigate();
  let ActionHandler = (e) => {
    if (e.target.value === "View") {
      navigate("/rating/view");
    }
  };
  let TableData = [
    {
      date: "JAN 4, 2022",
      name: "Willow Anderson",
      des: "Integer facilisis pulvinar molestie. Duis justo lectus...",
    },
    {
      date: "JAN 4, 2022",
      name: "Willow Anderson",
      des: "Integer facilisis pulvinar molestie. Duis justo lectus...",
    },

    {
      date: "JAN 4, 2022",
      name: "Willow Anderson",
      des: "Integer facilisis pulvinar molestie. Duis justo lectus...",
    },
    {
      date: "JAN 4, 2022",
      name: "Willow Anderson",
      des: "Integer facilisis pulvinar molestie. Duis justo lectus...",
    },
    {
      date: "JAN 4, 2022",
      name: "Willow Anderson",
      des: "Integer facilisis pulvinar molestie. Duis justo lectus...",
    },
    {
      date: "JAN 4, 2022",
      name: "Willow Anderson",
      des: "Integer facilisis pulvinar molestie. Duis justo lectus...",
    },
    {
      date: "JAN 4, 2022",
      name: "Willow Anderson",
      des: "Integer facilisis pulvinar molestie. Duis justo lectus...",
    },
  ];
  return (
    <SideMenu>
      <div className="page-container">
        <div className="page-header-button-main">
          <Button className="page-header-button" variant="text">
            <p className="page-header-button-text">Download</p>
          </Button>
        </div>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={3} sm={6} xs={12}>
              <div>
                <p className="header-input-heading">Search by user</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by user"
                />
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={6} xs={12}>
              <div>
                <p className="header-input-heading">Search by Ratings</p>
                <select className="header-dropdown">
                  <option value="all">All</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                </select>
              </div>
            </Grid>
            <Grid item xl={5} lg={5} md={5} sm={6} xs={12}>
              <DateRangePicker />
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={6} xs={12}>
              <Button className="header-apply-button" variant="text">
                <p className="header-apply-button-text">Apply</p>
              </Button>
            </Grid>
          </Grid>
        </Box>
        <br />
        <div className="table-container">
          <div className="table-header">
            <p className="table-heading">Staff</p>
          </div>
          <div className="table-data-container">
            <table>
              <thead>
              <tr>
                <th className="rating-table-date-heading">Date</th>
                <th className="rating-table-tutor-name-heading">Tutors Name</th>
                <th className="rating-table-course-name-heading">
                  Course name
                </th>
                <th className="rating-table-rating-heading">Ratings</th>
                <th className="rating-table-action-heading"></th>
                <th className="rating-table-analytics-heading"></th>
              </tr>
              </thead>
              {TableData.map((tableValue, tableIndex) => {
                return (
                  <tr key={tableIndex}>
                    <td className="table-date-data">{tableValue.date}</td>
                    <td className="table-data">{tableValue.name}</td>
                    <td className="table-data">{tableValue.des}</td>
                    <td className="table-data">
                      <Stack spacing={1}>
                        <Rating
                          name="half-rating-read"
                          defaultValue={4}
                          precision={1}
                          readOnly
                        />
                      </Stack>
                    </td>
                    <td className="table-data">
                      <select
                        className="table-action-dropdown"
                        onChange={ActionHandler}
                      >
                        <option value="">Action</option>
                        <option value="View">View</option>
                        <option value="Delete">Delete</option>
                      </select>
                    </td>
                    <td className="table-data">
                      <Button
                        className="table-analytics-chat-button"
                        onClick={() => navigate("/rating/analytics")}
                      >
                        <IoMdAnalytics color="#663399" size={20} />
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
          <div className="table-pagination-main">
            <Stack spacing={2}>
              <Pagination count={10} variant="outlined" shape="rounded" />
            </Stack>
          </div>
        </div>
      </div>
    </SideMenu>
  );
};
export default RatingPage;
